import { formatToReal } from "../../../utils/utils";
import TitleStripe from "../TitleStripe";

const RendaPresumidaPF = ({ data }) => {
  return (
    <>
      <TitleStripe>Renda Presumida</TitleStripe>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <div className="flex items-center gap-2">
          <div className="font-semibold">Faixa da renda:</div>
          <div>{data?.IncomeRangeValue}</div>
        </div>
        <div className="flex items-center gap-2">
          <div className="font-semibold">Descrição:</div>
          <div>{data?.IncomeRangeDescription}</div>
        </div>
        <div className="flex items-center gap-2">
          <div className="font-semibold">Faixa de renda em salários mínimos:</div>
          <div>{data?.MinimumWageRangeDescription}</div>
        </div>
        <div className="flex items-center gap-2">
          <div className="font-semibold">Renda presumida:</div>
          <div>{formatToReal(data?.PresumedIncome)}</div>
        </div>
        <div className="flex items-center gap-2">
          <div className="font-semibold">Data de referência:</div>
          <div>
            {data?.DateReference?.Day}/{data?.DateReference?.Month}/
            {data?.DateReference?.Year}
          </div>
        </div>
      </div>
    </>
  );
};

export default RendaPresumidaPF;
